export const characterDefault = Object.freeze({});
